import api from './api';

export const getDashboardContent = async () => {
  const response = await api.get('/dashboard-content');
  return response.data;
};

export const updateBanner = async (file) => {
  const formData = new FormData();
  formData.append('image', file);
  const response = await api.put('/dashboard-content/admin/banner', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const updateAnnouncement = async (text) => {
  const response = await api.put('/dashboard-content/admin/announcement', { text });
  return response.data;
};
